import { render, staticRenderFns } from "./UserFormActions.vue?vue&type=template&id=46d4d136&scoped=true"
import script from "./UserFormActions.vue?vue&type=script&lang=js"
export * from "./UserFormActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d4d136",
  null
  
)

export default component.exports